import { type ComputedRef, computed, ref } from "@nuxtjs/composition-api";
import { defineStore } from "pinia";

export const useCreatorShop = defineStore("creator-shop", () => {
  const _beganJourneyFromShop = ref<boolean>(false);
  const _lastSeenShopTab = ref<string | null>(null);
  const _referringShopTab = ref<string | null>(null);

  const getReferringShopTab: ComputedRef<string | null> = computed(() =>
    _beganJourneyFromShop.value ? _referringShopTab.value : null,
  );

  const getLastSeenShopTab: ComputedRef<string | null> = computed(() =>
    _beganJourneyFromShop.value ? _lastSeenShopTab.value : null,
  );

  function beginShopTabJourney(): void {
    _beganJourneyFromShop.value = true;
  }

  function completeShopTabJourney(): void {
    _beganJourneyFromShop.value = false;
  }

  function setLastSeenShopTab(value: string): void {
    _lastSeenShopTab.value = value;
  }

  function setReferringShopTab(value?: string | null): void {
    _referringShopTab.value = value || (value === null ? null : _lastSeenShopTab.value);
  }

  function $reset() {
    _beganJourneyFromShop.value = false;
    _lastSeenShopTab.value = null;
    _referringShopTab.value = null;
  }

  return {
    _beganJourneyFromShop,
    _lastSeenShopTab,
    _referringShopTab,
    getReferringShopTab,
    getLastSeenShopTab,
    setLastSeenShopTab,
    setReferringShopTab,
    beginShopTabJourney,
    completeShopTabJourney,
    $reset,
  };
});
